export function getUri(path = '') {
    return `${window.webApiRootUrl}${path}`;
}

export function getNonApiUri(path = '') {
    // window.rootUrl is set to '/' in Index.cshtml. Since path may already start with '/', we avoid adding an extra '/' if it does.
    if (path.startsWith('/')) {
        return path;
    }

    return `${window.rootUrl}${path}`;
}
